import PropTypes from 'prop-types'
import useError from '../../hooks/useError'
import Input from '../../ui/Input'
import GenericSelect from '../genericSelect/GenericSelect'
import styles from './GenericModal.module.css'

export const GenericInputs = ({
  content = {},
  value = '',
  onChange,
  errores = {},
  editMode,
  filaIndex = -1,
  readOnly = false
}) => {
  const { type, name, label, placeholder, options, isFullWidth, isEditable, ...inputProps } =
    content
  delete inputProps.isGrid
  const { ShowError } = useError(errores, name)

  const obtenerValorFinal = (valorIngresado) => {
    if (type !== 'number') {
      return valorIngresado
    }

    if (valorIngresado === '' || valorIngresado === null || valorIngresado === undefined) {
      return ''
    }

    const maxConfigurado =
      inputProps.max !== undefined && inputProps.max !== null ? Number(inputProps.max) : null

    if (maxConfigurado === null || Number.isNaN(maxConfigurado)) {
      return valorIngresado
    }

    const valorNumerico = Number(valorIngresado)
    if (Number.isNaN(valorNumerico)) {
      return valorIngresado
    }

    return valorNumerico > maxConfigurado ? String(value ?? '') : valorIngresado
  }

  const inputName = filaIndex === -1 ? name : `${name}_${filaIndex}`
  const enGrilla = filaIndex !== -1

  return (
    <div
      className={
        enGrilla
          ? styles.gridField
          : `${styles.inputs} ${isFullWidth ? styles.fullWidth : styles.partialWidthInputs}`
      }
    >
      {filaIndex === -1 && type !== 'checkbox' && <label htmlFor={name}>{label}</label>}
      {type === 'checkbox' ? (
        <div className={styles.checkboxRow}>
          <input
            type="checkbox"
            id={inputName}
            name={inputName}
            checked={Boolean(value)}
            disabled={readOnly || (editMode && !isEditable)}
            onChange={(e) => {
              const { checked } = e.target
              if (filaIndex !== -1) {
                onChange({ target: { name, value: checked, checked, type, filaIndex } })
              } else {
                onChange({ target: { name, value: checked, checked, type } })
              }
            }}
            {...inputProps}
          />
          <label htmlFor={inputName}>{label}</label>
          <ShowError />
        </div>
      ) : type === 'select' ? (
        <GenericSelect
          options={(options || []).map((option) => ({
            value: option.value,
            label: option.label,
            key: option.key
          }))}
          errores={errores}
          id={inputName}
          name={inputName}
          disabled={readOnly || (editMode && !isEditable)}
          value={value}
          placeholder={placeholder}
          onChange={(val) => {
            if (filaIndex !== -1) {
              onChange({
                target: { name, value: val, filaIndex }
              })
            } else {
              onChange({ target: { name, value: val } })
            }
          }}
          {...inputProps}
        />
      ) : type === 'textarea' ? (
        <>
          <textarea
            id={inputName}
            name={inputName}
            value={value}
            onChange={(e) => {
              const valorFinal = obtenerValorFinal(e.target.value)

              if (filaIndex !== -1) {
                onChange({ target: { name, value: valorFinal, filaIndex } })
              } else {
                onChange({ target: { name, value: valorFinal } })
              }
            }}
            placeholder={placeholder || ''}
            className="input-text-bordered"
            disabled={readOnly || (editMode && !isEditable)}
            {...inputProps}
          ></textarea>
          {inputProps.maxLength && (
            <div className={styles.textareaContador}>
              {String(value ?? '').length}/{inputProps.maxLength}
            </div>
          )}
          <ShowError />
        </>
      ) : (
        <Input
          type={type}
          name={inputName}
          value={value}
          onChange={(val) => {
            const valorFinal = obtenerValorFinal(val.target.value)

            if (filaIndex !== -1) {
              onChange({
                target: { name, value: valorFinal, filaIndex }
              })
            } else {
              onChange({ target: { name, value: valorFinal } })
            }
          }}
          placeholder={placeholder || ''}
          className="input-text-bordered"
          label={label}
          errores={errores}
          disabled={readOnly || (editMode && !isEditable)}
          {...inputProps}
        />
      )}
    </div>
  )
}

GenericInputs.propTypes = {
  content: PropTypes.shape({
    type: PropTypes.oneOf([
      'text',
      'email',
      'date',
      'number',
      'password',
      'select',
      'checkbox',
      'textarea'
    ]),
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    isFullWidth: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string.isRequired,
        key: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    )
  }),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  errores: PropTypes.object,
  editMode: PropTypes.bool,
  filaIndex: PropTypes.number,
  readOnly: PropTypes.bool
}
